(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxPrintQueuesMultiSaveDialog(
    $timeout, toastr, $filter, $location, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/printQueuePropertiesMulti/printQueuesSaveDialog/printQueuesMultiSaveDialog.template.html',
      link: function(scope) {

        let saveCounter = 0;
        scope.middleStage = angular.copy(scope.context.middleStage);
        scope.printQueues = angular.copy(scope.context.printQueues);
        scope.printQueuesOriginal = angular.copy(scope.context.printQueuesOriginal);
        scope.printQueueSettingsModel = angular.copy(scope.context.printQueueSettingsModel);
        scope.saveComplete = false;
        scope.dialogMessage = 'WorkingOnIt';

        (function() {

          prepPrintQueues();
        })();

        function prepPrintQueues () {
          scope.printQueues.forEach((queue) => {
            queue.saveStatus = {
              state: 'PENDING',
              startTime: new Date().getTime(),
              endTime: null
            }
          });

          executeThrottledPrintQueueSave();
        }

        function executeThrottledPrintQueueSave () {
          $timeout(() => {
            let modifiedPrintQueue = modifyPrintQueue(scope.printQueues[saveCounter])
            const modifiedPrintQueueId = modifiedPrintQueue.info._links.self.href;
            let isCorrectPrintQueue = (queue) => queue.info._links.self.href === modifiedPrintQueueId;
            let printQueueOriginal = scope.printQueuesOriginal.find(isCorrectPrintQueue);
            saveCounter += 1;

            $timeout(() => {
              savePrintQueue(printQueueOriginal, modifiedPrintQueue, saveCounter);
            }, 500)
            if (saveCounter < scope.printQueues.length) {
              executeThrottledPrintQueueSave();
            }

          }, 500)
        };

        function modifyPrintQueue (printQueue) {
          printQueue.saveStatus.state = 'SAVING';
          const excludedAttrs = ['viaTheCloud', 'global', 'releaseFromOtherNetworksEnabled'];
          for (let key in scope.printQueueSettingsModel) {
            let skipAttr = (attr) => attr === key;
            if (!scope.middleStage[key]) {
              if (!excludedAttrs.find(skipAttr)) {
                printQueue.info[key] = scope.printQueueSettingsModel[key];
              }
            }
          }

          if (!scope.middleStage.viaTheCloud) {
            printQueue.info.global = scope.printQueueSettingsModel.global;
            printQueue.info.releaseFromOtherNetworksEnabled = scope.printQueueSettingsModel.releaseFromOtherNetworksEnabled;
          }

          if (printQueue.info.signId === '000') {
            printQueue.info.global = true;
            printQueue.info.releaseFromOtherNetworksEnabled = false;
          }

          return printQueue;
        };

        function savePrintQueue(originalPrintQueueINPUT, modifiedPrintQueueINPUT, saveCounterIntINPUT) {

          let originalPrintQueue = originalPrintQueueINPUT;
          let modifiedPrintQueue = modifiedPrintQueueINPUT;
          let saveCounterInt = saveCounterIntINPUT;

          if (scope.context.mappedNetworks && originalPrintQueue.info.signId !== '000') {
            const addNetworks =  scope.context.mappedNetworks.addSelectedNetworks;
            const removeNetworks =  scope.context.mappedNetworks.removeSelectedNetworks;

            if (addNetworks.length > 0 && removeNetworks.length > 0) {
              originalPrintQueue.addNetworkToReleaseOtherNetworkList(addNetworks).then(function(response) {
                originalPrintQueue.removeNetworkFromReleaseOtherNetworkList(removeNetworks).then(function(response) {
                  save();
                }).catch(function(error) {
                  save();
                });
              }).catch(function(error) {
                originalPrintQueue.removeNetworkFromReleaseOtherNetworkList(removeNetworks).then(function(response) {
                  save();
                }).catch(function(error) {
                  save();
                });
                save();
              });
            } else if (addNetworks.length > 0 && removeNetworks.length === 0) {
              originalPrintQueue.addNetworkToReleaseOtherNetworkList(addNetworks).then(function(response) {
                save();
              }).catch(function(error) {
                save();
              });
            } else if (addNetworks.length === 0 && removeNetworks.length > 0) {
              originalPrintQueue.removeNetworkFromReleaseOtherNetworkList(removeNetworks).then(function(response) {
                save();
              }).catch(function(error) {
                save();
              });
            } else {
              save();
            }
          } else {
            save();
          }

          function save () {
            originalPrintQueue.saveChanges(modifiedPrintQueue).then(function(response) {
              modifiedPrintQueue.saveStatus.state = 'DONE';
              modifiedPrintQueue.saveStatus.endTime = new Date().getTime() - modifiedPrintQueue.saveStatus.startTime;
              if (saveCounterInt === scope.printQueues.length) {
                saveCounter = 0;
                toast()
                $rootScope.$broadcast('REFRESH_MULTI_EDIT_PRINTQUEUES');
              }
            }).catch(function(error) {
              modifiedPrintQueue.saveStatus.error = error.data.errorText;
              modifiedPrintQueue.saveStatus.state = 'FAILED';
              modifiedPrintQueue.saveStatus.endTime = new Date().getTime() - modifiedPrintQueue.saveStatus.startTime;
              if (saveCounter === scope.printQueues.length) {
                saveCounter = 0;
                toast()
                $rootScope.$broadcast('REFRESH_MULTI_EDIT_PRINTQUEUES');
              }
            });
          }



        };

        function toast() {
          scope.saveComplete = true;
          scope.context.form.$setPristine();
          if (scope.printQueues.every((queue) => queue.saveStatus.error)) {
            scope.dialogMessage = 'Failed';
            toastr.error($filter('translate')('ERROR'))
          }

          if (scope.printQueues.some((queue) => queue.saveStatus.error)) {
            scope.dialogMessage = 'WARNING';
            toastr.warning($filter('translate')('WARNING'))
          }

          if (scope.printQueues.every((queue) => !queue.saveStatus.error)) {
            scope.dialogMessage = 'ChangesSaved';
            toastr.success($filter('translate')('ChangesSaved'))
          }
        }

        scope.closeAndExit = function () {
          scope.callback()
          // $location.path('/printQueues').search({printQueuePage: scope.context.originPage});
        }

      }
    };
  }

  pxPrintQueuesMultiSaveDialog.$inject = [
    '$timeout', 'toastr', '$filter', '$location', '$rootScope'
  ];

  angular
    .module('printix-admin')
    .directive('pxPrintQueuesMultiSaveDialog', pxPrintQueuesMultiSaveDialog);

})();
